import React from "react";
import Gettingstartedpage1 from "./Gettingstartedpage1";
import Herosection from "./Herosection";

export default function Home() {
    return (
      <>
      <Herosection/>
      <Gettingstartedpage1 />
      </>
    );
}
  